import { render } from "./hrbp-detail.vue?vue&type=template&id=78e66032&scoped=true"
import script from "./hrbp-detail.vue?vue&type=script&lang=js"
export * from "./hrbp-detail.vue?vue&type=script&lang=js"

import "./hrbp-detail.vue?vue&type=style&index=0&id=78e66032&lang=less&scoped=true"

import exportComponent from "/Users/cain/Workspaces/projects/roar/roar-fe/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.30_vue@3.5.30_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78e66032"]])

export default __exports__